/**
 * The CustomerWorldMap's category color palette, extracted from the component.
 * `generateColorPalette` assigns each distinct value a stable color, cycling
 * the 20-swatch palette by insertion index when there are more categories than
 * swatches. Pure + deterministic, so the marker coloring is unit-tested. No
 * money / reseller here — wall-neutral.
 */

/** 20 visually distinct swatches; reused cyclically for >20 categories. */
export const COLOR_PALETTE = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#45B7D1', // Blue
  '#96CEB4', // Green
  '#FFEAA7', // Yellow
  '#DDA0DD', // Plum
  '#98D8C8', // Mint
  '#F7DC6F', // Light yellow
  '#BB8FCE', // Light purple
  '#85C1E9', // Light blue
  '#58D68D', // Light green
  '#F8C471', // Orange
  '#EC7063', // Light red
  '#AED6F1', // Pale blue
  '#A9DFBF', // Pale green
  '#F9E79F', // Pale yellow
  '#D2B4DE', // Pale purple
  '#A3E4D7', // Pale teal
  '#FADBD8', // Pale pink
  '#D5DBDB', // Light gray
]

/**
 * Map each item to a palette color by its position, wrapping around the
 * palette for lists longer than it. The modulo index is always in range, so
 * the lookup is non-null by construction.
 */
export function generateColorPalette(items: string[]): Record<string, string> {
  const palette: Record<string, string> = {}
  items.forEach((item, index) => {
    palette[item] = COLOR_PALETTE[index % COLOR_PALETTE.length]!
  })
  return palette
}
